module.exports = __webpack_public_path__ + "static/PM_LNSG_Website-d5e81c974a87e9dce00887d357e04b1d.jpg";